import styled, { css } from 'styled-components';

import DefaultButton, { activeState, defaultState, hoverState } from '../Button';

const checkedActiveState = css`
  &:focus,
  & {
    ${activeState}
  }
`;

export const Button = styled(DefaultButton)<{ checked?: boolean }>`
  &:focus {
    ${defaultState}
  }

  ${props => props.checked && checkedActiveState}

  &:hover {
    ${hoverState}
  }
`;
